export const GET_NOTIFICATIONS_CONFIG = 'GET_NOTIFICATIONS_CONFIG';
export const SET_NOTIFICATIONS_CONFIG_PAGINATION = 'SET_NOTIFICATIONS_CONFIG_PAGINATION';
export const SET_NOTIFICATIONS_CONFIG_FILTERS = 'SET_NOTIFICATIONS_CONFIG_FILTERS';
export const RESET_NOTIFICATIONS_CONFIG = 'RESET_NOTIFICATIONS_CONFIG';
export const TOGGLE_NOTIFICATION_CONFIG = 'TOGGLE_NOTIFICATION_CONFIG';
export const ADD_NOTIFICATION_CONFIG = 'ADD_NOTIFICATION_CONFIG';
export const UPDATE_NOTIFICATION_CONFIG = 'UPDATE_NOTIFICATION_CONFIG';
export const GET_NOTIFICATION_CONFIG_BY_ID = 'GET_NOTIFICATION_CONFIG_BY_ID';
export const RESET_NOTIFICATION_CONFIG_FORM = 'RESET_NOTIFICATION_CONFIG_FORM';
export const GET_NOTIFICATION_CONFIG_FORM_CONFIG = 'GET_NOTIFICATION_CONFIG_FORM_CONFIG';
export const MODIFY_EDITING_NOTIFICATION_CONFIG = 'MODIFY_EDITING_NOTIFICATION_CONFIG';
export const ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG =
  'ADD_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG';
export const REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG =
  'REMOVE_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG';

export const UPDATE_SELF_NOTIFICATION_CONFIG = 'UPDATE_SELF_NOTIFICATION_CONFIG';

//Groups
export const MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG =
  'MODIFY_CUSTOM_FIELD_EDITING_NOTIFICATION_CONFIG';

export const notifications_elementsBySections = {
  assets: [
    'notify.assets.add',
    'notify.assets.edit',
    // "notify.assets.edit_create_historic",// probably need to remove
    'notify.assets.edit_request',
    'notify.assets.edit_accept',
    'notify.assets.edit_reject',
    'notify.assets.disable',
    'notify.assets.restore',

    // In develoopment
    'notify.assets.out',
    'notify.assets.in',
    'notify.assets.reject_out',
    'notify.assets.acept_out',
    'notify.assets.out_request',
  ],
  // reports: ["notify.reports.depreciation", "notify.reports.disabled"],
};



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_config/constants/notifications_config_constants.js